module.exports = __webpack_public_path__ + "img/explainer-15.5a394a01.jpg";